import { MESES } from './const';

export async function generateYears() {
  const anioActual = new Date().getFullYear();
  const anioInicio = 1927;
  return Array.from({ length: anioActual - anioInicio + 1 }, (_, i) => {
    const anio = anioActual - i;
    return { id: anio.toString(), label: anio.toString() };
  });
}

export async function generateDay(mes, anio) {
  const diasEnMes = mes && anio ? new Date(anio, mes, 0).getDate() : 31;
  return Array.from({ length: diasEnMes }, (_, i) => {
    const dia = (i + 1).toString().padStart(2, '0');
    return { id: dia, label: dia };
  });
}

export async function getDateInput(month, year) {
  const date = {
    days: await generateDay(month, year),
    months: MESES,
    years: await generateYears(),
  };
  return date;
}
